import { useSnapshot } from 'valtio';
import { dismissBanner } from '../store-actions/connectors-store-actions';
import ConnectorsStore from '../stores/connectors-store';
import { shouldShowBanner } from '../utils/connectivity-utils';

const useConnectivityBanner = () => {
  const { noConnectionBanner, scanType, connectivityBannerDismissed } =
    useSnapshot(ConnectorsStore);

  const show = shouldShowBanner({
    scanType,
    info: noConnectionBanner,
    dismissed: connectivityBannerDismissed,
  });

  return {
    show,
    noConnectionBanner,
    dismissBanner,
  };
};

export default useConnectivityBanner;
